// extracted by mini-css-extract-plugin
export default {"stars":"review_stars__93J3G","message":"review_message__tnCmI","author":"review_author__hMQoW"};